import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=139ff73d&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports